document.addEventListener('turbolinks:load', () => {
    let textSizeModifier = 1 // 1.75 | 1.4 | 1

    const selfGuidedQuizStationScreenPreview = document.getElementById('selfGuidedQuizStationScreenPreview')
    const guestQuizStationScreenPreview = document.getElementById('guestQuizStationScreenPreview')
    const sgScreen = document.getElementById('sgScreen')
    const checkBoxes = document.getElementsByClassName('myTourQuizCheckBox')
    const freeTextInputs = document.getElementsByClassName('freeTextInput')
    const quizNextQuestion = document.getElementById('quizNextQuestion')
    const quizCheckAnswers = document.getElementById('quizCheckAnswers')
    const currentTextSize = document.getElementById('currentTextSize')
    const quizQuestionType = document.getElementById('quizQuestionType')
    const quizPreviewForm = document.getElementById('quizPreviewForm')
    const currentDeviceLanguage = document.getElementById('currentDeviceLanguage')


    if ((selfGuidedQuizStationScreenPreview !== null || guestQuizStationScreenPreview !== null) && sgScreen !== null) {
        // text_size can only be changed in selfguided mode. In guided quizzes the text size will be ignored
        if (currentTextSize != null && selfGuidedQuizStationScreenPreview){
            if (currentTextSize.value === "very large") {
                textSizeModifier = 1.75
            } else if (currentTextSize.value === "large") {
                textSizeModifier = 1.4
            }
        }
        resize()
        initCheckboxes()
        if(quizNextQuestion !== null && quizCheckAnswers !== null && quizQuestionType !== null && quizPreviewForm !== null){
            quizCheckAnswers.addEventListener('click', checkAnswers)
        }

    }

    function resize() {
        let resizeObserver = new ResizeObserver(() => {
            const currentSgScreenHeight = sgScreen.getBoundingClientRect().height

            // freetext input
            for (let freeTextInput of freeTextInputs) {
                if (freeTextInput !== null) {
                    freeTextInput.style.fontSize = `${currentSgScreenHeight / 45}px`
                    freeTextInput.style.lineHeight = `${currentSgScreenHeight / 25}px`
                }
            }

            if(quizNextQuestion !== null && quizCheckAnswers !== null) {
                //Size of text-base
                let fontSize = (currentSgScreenHeight / 48) * textSizeModifier
                let lineHeight = (currentSgScreenHeight / 48) * textSizeModifier

                quizCheckAnswers.style.fontSize = `${fontSize}px`
                quizCheckAnswers.style.lineHeight = `${lineHeight}px`

                quizNextQuestion.style.fontSize = `${fontSize}px`
                quizNextQuestion.style.lineHeight = `${lineHeight}px`

                quizNextQuestion.parentElement.style.fontSize = `${fontSize}px`
                quizNextQuestion.parentElement.style.lineHeight = `${lineHeight}px`
            }
        })
        resizeObserver.observe(sgScreen);
    }

    function initCheckboxes() {
        for (let c of checkBoxes) {
            if (c.checked) {
                const color = '#9ca3af' // use '#9ca3af' if solution_screen is shown
                c.style.borderColor = color
                c.style.backgroundImage = `url("data:image/svg+xml,%3csvg viewBox='0 0 200 200'  fill='${color.replace('#', '%23')}' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M 0.00,0.00 C 0.00,0.00 200.00,0.00 200.00,0.00 200.00,0.00 200.00,200.00 200.00,200.00 200.00,200.00 0.00,200.00 0.00,200.00 0.00,200.00 0.00,0.00 0.00,0.00 Z M 140.00,56.42 C 132.99,58.88 128.14,64.86 123.00,70.00 123.00,70.00 97.00,96.00 97.00,96.00 94.48,98.52 84.60,109.12 82.00,109.80 78.74,110.66 75.07,106.06 73.00,104.00 67.95,98.97 62.96,92.60 55.00,93.56 47.77,94.43 42.68,100.73 43.56,108.00 44.20,113.35 47.42,116.36 51.00,120.00 51.00,120.00 67.00,136.00 67.00,136.00 70.95,139.89 74.17,143.39 80.00,143.89 89.51,144.71 95.94,136.06 102.00,130.00 102.00,130.00 137.00,95.00 137.00,95.00 141.21,90.79 152.20,80.43 154.77,76.00 160.27,66.56 154.55,54.34 140.00,56.42 Z'/%3e%3c/svg%3e")`
            } else {
                c.style.backgroundImage = 'none'
            }


            c.addEventListener('change', function() {
                if (this.checked) {
                    const color = c.dataset.color // use '#9ca3af' if solution_screen is shown
                    c.style.borderColor = color
                    c.style.backgroundImage = `url("data:image/svg+xml,%3csvg viewBox='0 0 200 200'  fill='${color.replace('#', '%23')}' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M 0.00,0.00 C 0.00,0.00 200.00,0.00 200.00,0.00 200.00,0.00 200.00,200.00 200.00,200.00 200.00,200.00 0.00,200.00 0.00,200.00 0.00,200.00 0.00,0.00 0.00,0.00 Z M 140.00,56.42 C 132.99,58.88 128.14,64.86 123.00,70.00 123.00,70.00 97.00,96.00 97.00,96.00 94.48,98.52 84.60,109.12 82.00,109.80 78.74,110.66 75.07,106.06 73.00,104.00 67.95,98.97 62.96,92.60 55.00,93.56 47.77,94.43 42.68,100.73 43.56,108.00 44.20,113.35 47.42,116.36 51.00,120.00 51.00,120.00 67.00,136.00 67.00,136.00 70.95,139.89 74.17,143.39 80.00,143.89 89.51,144.71 95.94,136.06 102.00,130.00 102.00,130.00 137.00,95.00 137.00,95.00 141.21,90.79 152.20,80.43 154.77,76.00 160.27,66.56 154.55,54.34 140.00,56.42 Z'/%3e%3c/svg%3e")`
                } else {
                    c.style.backgroundImage = 'none'
                    c.style.borderColor = c.dataset.theme_color
                }
            })
        }
    }

    function checkAnswers() {
        //submit at the start, afterwards all inputs are disabled and will not submit
        quizPreviewForm.submit()
        if (quizQuestionType.value === "single_select") {
            if ($("input[name=quizAnswer]:checked").length < 1) {
                // Do nothing if no answer is checked
                return
            }
            let answerInfo = document.createElement('p')
            answerInfo.className = "text-2xs ml-6.6p"
            for (let answer of $("input[name=quizAnswer]")) {
                controlListAnswer(answer, "single_select")
            }
        } else if (quizQuestionType.value === "multi_select") {
            if ($("input[name='quizAnswer[]']:checked").length < 1){
                // Do nothing if no answer is checked
                return
            }
            for (let answer of $("input[name='quizAnswer[]']")) {
                controlListAnswer(answer, "multi_select")
            }
        } else if (quizQuestionType.value === "freetext" && $("#quizFreetextAnswer")[0] !== null){
            let freetextAnswer = $("#quizFreetextAnswer")[0]
            if (freetextAnswer.value === ""){
                // Do nothing if no answer is present
                return
            }
            controlFreetextAnswer(freetextAnswer)
        }
        quizCheckAnswers.classList.add('hidden')
        quizNextQuestion.classList.remove('hidden')
    }

    // Control an answer
    // Check if the given answer is checked and right -> green border and text
    // Given answer is checked and wrong -> red border and text
    // Given answer is not checked but right -> yellow border and text
    // Given answer is not checked and wrong -> Don't do anything
    function controlListAnswer(answer, question_type){
        let usedLang
        if (currentDeviceLanguage !== null) {
            usedLang = currentDeviceLanguage.value
        } else {
            usedLang = "en"
        }
        let answerInfo = document.createElement('p')
        answerInfo.className = "text-2xs ml-6.6p"
        const currentSgScreenHeight = sgScreen.getBoundingClientRect().height
        // Calculate size for text-2xs
        let fontSize = (currentSgScreenHeight / 60) * textSizeModifier
        let lineHeight = (currentSgScreenHeight / 60) * textSizeModifier
        answerInfo.style.fontSize = `${fontSize}px`
        answerInfo.style.lineHeight = `${lineHeight}px`

        let borderClasses = ["border", "roundedBorders", "mt-1.1p"]
        if (question_type === "single_select"){
            borderClasses.push("rounded-2xl")
        } else if (question_type === "multi_select"){
            borderClasses.push("rounded-lg")
        }
        let answerParent = answer.parentElement
        if (answer.checked && answer.dataset.is_solution === "true") {
            answerParent.classList.add(...borderClasses, "border-green-400")
            answerParent.classList.remove("mt-5.5p")
            answerInfo.classList.add('text-green-400')
            answerInfo.innerHTML = I18n.t('js.sg_preview_quiz_right_answer', { locale: usedLang })
            answerParent.parentElement.insertBefore(answerInfo, answerParent)
        } else if (answer.checked) {
            answerParent.classList.add(...borderClasses, "border-red-400")
            answerParent.classList.remove("mt-5.5p")
            answerInfo.classList.add('text-red-400')
            answerInfo.innerHTML = I18n.t('js.sg_preview_quiz_wrong_answer', { locale: usedLang })
            answerParent.parentElement.insertBefore(answerInfo, answerParent)
        } else if (answer.dataset.is_solution === "true") {
            answerParent.classList.add(...borderClasses, "border-yellow-400")
            answerParent.classList.remove("mt-5.5p")
            answerInfo.classList.add('text-yellow-300')
            if (question_type === "single_select") {
                answerInfo.innerHTML = I18n.t('js.sg_preview_quiz_eval_right', {locale: usedLang})
            } else if (question_type === "multi_select") {
                answerInfo.innerHTML = I18n.t('js.sg_preview_quiz_other_correct', {locale: usedLang})
            }
            answerParent.parentElement.insertBefore(answerInfo, answerParent)
        }
        answer.disabled = true
        answerParent.classList.add("text-gray-400")
        if (question_type === "multi_select"){
            const color = "#9ca3af" //gray-400
            if (answer.checked) {
                answer.style.borderColor = color
                answer.style.backgroundImage = `url("data:image/svg+xml,%3csvg viewBox='0 0 200 200'  fill='${color.replace('#', '%23')}' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M 0.00,0.00 C 0.00,0.00 200.00,0.00 200.00,0.00 200.00,0.00 200.00,200.00 200.00,200.00 200.00,200.00 0.00,200.00 0.00,200.00 0.00,200.00 0.00,0.00 0.00,0.00 Z M 140.00,56.42 C 132.99,58.88 128.14,64.86 123.00,70.00 123.00,70.00 97.00,96.00 97.00,96.00 94.48,98.52 84.60,109.12 82.00,109.80 78.74,110.66 75.07,106.06 73.00,104.00 67.95,98.97 62.96,92.60 55.00,93.56 47.77,94.43 42.68,100.73 43.56,108.00 44.20,113.35 47.42,116.36 51.00,120.00 51.00,120.00 67.00,136.00 67.00,136.00 70.95,139.89 74.17,143.39 80.00,143.89 89.51,144.71 95.94,136.06 102.00,130.00 102.00,130.00 137.00,95.00 137.00,95.00 141.21,90.79 152.20,80.43 154.77,76.00 160.27,66.56 154.55,54.34 140.00,56.42 Z'/%3e%3c/svg%3e")`
            } else {
                answer.style.backgroundImage = 'none'
                answer.style.borderColor = color
            }
        } else {
            answer.style.color = "#9ca3af" //gray-400
        }
    }

    function controlFreetextAnswer(answer){
        let usedLang
        if (currentDeviceLanguage !== null) {
            usedLang = currentDeviceLanguage.value
        } else {
            usedLang = "en"
        }
        let answers_arr = answer.dataset.correct_answer.toLowerCase().split('|')
        let borderText = answer.nextElementSibling
        answer.classList.remove('border-blue-400')
        answer.disabled = true
        borderText.classList.remove('text-blue-400')
        if (answers_arr.includes(answer.value.toLowerCase())){
            answer.classList.add('border-green-400')
            borderText.classList.add('text-green-400')
            borderText.innerHTML = I18n.t('js.sg_preview_quiz_right_answer', { locale: usedLang })
        } else {
            answer.classList.add('border-red-400')
            borderText.classList.add('text-red-400')
            borderText.innerHTML = I18n.t('js.sg_preview_quiz_wrong_answer', { locale: usedLang })
            let parentDiv = answer.parentElement.cloneNode(true)
            let correct_answer = parentDiv.childNodes[1]
            correct_answer.classList.add('border-yellow-300')
            correct_answer.value = answer.dataset.correct_answer.split('|')[0] // Without lowercase
            let correct_border = parentDiv.childNodes[3]
            correct_border.classList.add('text-yellow-300')
            correct_border.innerHTML = I18n.t('js.sg_preview_quiz_eval_right', { locale: usedLang })
            answer.parentElement.parentElement.appendChild(parentDiv)
        }
    }
})